// extracted by mini-css-extract-plugin
export default {"wrapper":"styles_wrapper__VWv9V","container_video":"styles_container_video__YWK1Q","video":"styles_video__MgXEj","container_content":"styles_container_content__o4mBR"};